<div class="confirm-jobsite__container text-left">
	<div class="confirm-jobsite__header">{{ appData.jobsites.disableJobSiteModalContent }}</div>
	<h5>{{ appData.jobsites.disableJobsiteModalText }}</h5>
	@if (disablingJobsite) {
		<cramo-loading-area [showTransparent]="true" />
	}
	<button class="cramo-btn cramo-btn-primary cramo-btn-block" (click)="disableTheJosite()">
		<cramo-icon iconName="delete" iconDisplay="inline" />
		<span>{{ appData.jobsites.disableJobsiteButtonText }}</span>
	</button>
</div>
